import React from 'react';

// Meta Business Manager's "Upload an HTML file to your root directory"
// verification method. Meta fetches
// /wtip4ajshjmxt5pqiwswkagver7k0g.html and looks for the token below.
//
// This project has no static root directory, so the token is served from a
// route instead. Meta's crawler does not always execute JavaScript, so the
// meta-tag method (see hooks/useFacebookDomainVerification.ts) remains the
// primary path; this is a fallback.
export const FACEBOOK_HTML_VERIFICATION_FILE = 'wtip4ajshjmxt5pqiwswkagver7k0g';
export function FacebookDomainVerificationPage() {
  return <pre data-id="element-1601" data-mp="26axh8kkmup50">{FACEBOOK_HTML_VERIFICATION_FILE}</pre>;
}